import {jwtDecode, JwtPayload} from "jwt-decode";
import {BounceRole} from "../../consumer/declarations";

type JwtPayloadType = JwtPayload & {
  role: BounceRole;
};

const USER_ID_PREFIX = "BU";

const isValidUserId = (userId: string): boolean => userId.startsWith(USER_ID_PREFIX);

const getTokenExpired = (decodedToken: JwtPayloadType | undefined) => {
  if (decodedToken?.exp) {
    const now = Math.floor(Date.now() / 1000);
    return now >= decodedToken.exp;
  }
  return false;
};

const getActiveTokenRole = (token: string | undefined): BounceRole | undefined => {
  if (!token) return undefined;
  const decodedToken = jwtDecode<JwtPayloadType>(token);
  return getTokenExpired(decodedToken) ? undefined : decodedToken.role;
};

export {getActiveTokenRole, getTokenExpired, isValidUserId};
export type {JwtPayloadType};
